import { ElementNode, $applyNodeReplacement } from 'lexical';
import './scss/Toggle.scss';

export class ToggleNode extends ElementNode {
  __open;

  static getType() {
    return 'toggle';
  }

  static clone(node) {
    return new ToggleNode(node.__open, node.__key);
  }

  constructor(open = true, key) {
    super(key);
    this.__open = open;
  }

  createDOM(config) {
    const dom = document.createElement('div');
    dom.className = `toggle-block ${this.__open ? 'open' : 'closed'}`;
    return dom;
  }

  updateDOM(prevNode, dom) {
    if (prevNode.__open !== this.__open) {
      dom.className = `toggle-block ${this.__open ? 'open' : 'closed'}`;
    }
    return false;
  }

  static importJSON(serializedNode) {
    const node = $createToggleNode(serializedNode.open);
    return node;
  }

  exportJSON() {
    return {
      ...super.exportJSON(),
      open: this.__open,
      type: 'toggle',
      version: 1,
    };
  }

  setOpen(open) {
    const writable = this.getWritable();
    writable.__open = open;
  }

  getOpen() {
    return this.__open;
  }

  collapseAtStart() {
    return true;
  }
}

export function $createToggleNode(open = true) {
  return $applyNodeReplacement(new ToggleNode(open));
}

export function $isToggleNode(node) {
  return node instanceof ToggleNode;
}
